import {SnackbarProvider, enqueueSnackbar} from 'notistack'
import {ListComponentsHoteleria} from '../../components/components'
import {FC, useState} from 'react'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import {yupResolver} from '@hookform/resolvers/yup'
import {newGuestSchema} from '../../../../util/validationHoteleria'
import {FormProvider, useForm} from 'react-hook-form'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {ResizeHandle} from '../../components/Layout/Container/ResizeHandle/ResizeHandle'
import ActionsContent from '../components/Actions'
import {TabModel} from '../../../../models'
import {GuestModel} from '../../features/guests/model'
import Swal from 'sweetalert2'
import {
  createGuestService,
  deleteGuestService,
  editGuestService,
} from '../../services/guest.service'
import {getSnackBarToast} from '../../../../util/snackBar'

const getSnackBar = (message: string, variant: boolean) => {
  enqueueSnackbar(message, {
    variant: variant ? 'success' : 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  })
}
const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsHoteleria[key]
  }
  return component
}

const GuestPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const [loading, setLoading] = useState(false)
  const methods = useForm<GuestModel>({
    resolver: yupResolver(newGuestSchema),
    defaultValues: {
      TurnoId: '',
      tipoEstadia: 'PERMANENTE',
      Campamento_label: '',
      CargoId: '',
    },
  })

  const handleDelete = async () => {
    // await new Promise((resolve) => setTimeout(resolve, 2000))
    // debugger

    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminarlos, no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      Swal.close()
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = [{Id: currentTabItem.idToDelete}]
        changeCurrentTabItem({...currentTabItem, loadingTable: true, deleted: false})
        const data = await deleteGuestService(id)
        if (!data.data.error) {
          setLoading(false)

          const obj: TabModel = {
            ...currentTabItem,
            idToDelete: '',
            loadingTable: false,
            deleted: true,
          }
          changeCurrentTabItem(obj)
          getSnackBarToast('Se eliminó con éxito', 'success')
        } else {
          setLoading(false)

          changeCurrentTabItem({...currentTabItem, loadingTable: false, deleted: false})
          getSnackBarToast(data.data.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: GuestModel) => {
    try {
      // setLoading(true)
      // getSnackBarToast('Se actualizó el registro correctamente', true)
      // setLoading(false)

      setLoading(true)
      let num1 = Number(data.Campoadicionalnum1)
      data.Campoadicionalnum1 = num1
      let num2 = Number(data.Campoadicionalnum2)
      data.Campoadicionalnum2 = num2
      let num3 = Number(data.Campoadicionalnum3)
      data.Campoadicionalnum3 = num3
      if (currentTabItem.idToEdit) {
        changeCurrentTabItem({...currentTabItem, loadingTable: true, updated: false})
        const response = await editGuestService(data)
        if (!response.data.error) {
          setLoading(false)
          getSnackBarToast('Se actualizó el registro correctamente', 'success')
          const obj: TabModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              ...currentTabItem.content,
              detailPanel: '',
            },
            loadingTable: false,
            updated: true,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          changeCurrentTabItem({...currentTabItem, loadingTable: false, updated: false})
          getSnackBarToast(response.data.message, 'error')
        }
      } else {
        const response = await createGuestService(data)
        if (!response.data.error) {
          setLoading(false)
          getSnackBarToast('Se creó con éxito', 'success')
          const obj: TabModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            content: {
              headerPanel: 'header-guests',
            },
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          getSnackBarToast(response.data.message, 'error')
        }
      }
    } catch (error) {
      getSnackBarToast('Hubo un error interno', 'error')
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='header-guests'
          textComponentGo='form-guest'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical'>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-hoteleria-header-${currentTabItem.title}`}
              id={`panel-hoteleria-header-${currentTabItem.title}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            {currentTabItem.showPanel && (
              <>
                <ResizeHandle />
                <Panel
                  className={'panel__box'}
                  collapsible={true}
                  defaultSize={50}
                  order={2}
                  key={`panel-hoteleria-detail-${currentTabItem.title}`}
                  id={`panel-hoteleria-detail-${currentTabItem.title}`}
                >
                  {renderPanelContent(currentTabItem.content.detailPanel)}
                </Panel>
              </>
            )}
          </PanelGroup>
        </ContainerWrapper>
      </form>
      <SnackbarProvider />
    </FormProvider>
  )
}

export {GuestPageWrapper}
